import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/icon';
import Tooltip from 'components/tooltip';
import Link from 'components/link';
import LinkButton from 'components/button/link';
import { classNames } from 'utils';

// App collections arrive as "apps.<app id>.<name>" (URL param) or "apps/<app id>/<name>",
// while their model IDs are "com.app_<app id>.<name>"
export function modelLinkId(model) {
  const match = String(model).match(/^apps[./]([^./]+)[./](.+)$/);
  return match
    ? `com.app_${match[1]}.${encodeURIComponent(match[2])}`
    : `com.${encodeURIComponent(model)}`;
}

export default class ModelLink extends React.PureComponent {
  static contextTypes = {
    openModal: PropTypes.func,
  };

  static propTypes = {
    model: PropTypes.string.isRequired,
    zone: PropTypes.string,
    tooltip: PropTypes.bool,
    className: PropTypes.string,
  };

  onClick = (event) => {
    event.preventDefault();

    const { zone, model } = this.props;

    this.context.openModal('EditModel', {
      zone,
      params: { id: modelLinkId(model) },
    });
  };

  render() {
    const {
      className,
      model,
      tooltip,
      buttonType = undefined,
      icon = true,
    } = this.props;

    const Wrapper = buttonType === null ? Link : LinkButton;

    return (
      <Wrapper
        to={`/settings/models/${modelLinkId(model)}`}
        className={classNames('model-link', className)}
        onClick={this.onClick}
        type={buttonType !== undefined ? buttonType : 'sub button-sm'}
      >
        {tooltip ? (
          <Tooltip message="Edit model fields">
            <Icon fa="cube" />
          </Tooltip>
        ) : (
          <Fragment>
            {icon !== false && (
              <Fragment>
                <Icon fa="cube" />
                &ensp;
              </Fragment>
            )}
            Edit fields
          </Fragment>
        )}
      </Wrapper>
    );
  }
}
